import api from '../api';
let apiUrl = 'product-groups';

const state = {
    data: {}
};

const actions = {
    index: async ({ commit }, config) => {
        if (!config.params.product_category_id) {
            throw 'product_category_id is not set in params';
        }

        return await api
            .get(`/api/v1/${apiUrl}`, config)
            .then((response) => {
                commit('setByProductCategoryId', {
                    data: response.data,
                    product_category_id: config.params.product_category_id
                });
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    }
};

const mutations = {
    setByProductCategoryId(state, data) {
        state.data[data.product_category_id] = {
            data: data.data,
            meta: data.meta
        };
    }
};

const getters = {
    get: (state) => {
        return state.data;
    },
    getMeta: (state) => {
        return state.meta;
    },
    getByProductCategoryId: (state) => (id) => {
        return state.data[id];
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
